import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { store } from "../../../../Redux/store";
import { useCallback } from "react";
import { Table_ClearSelectedOrders, Table_DeSelectOrder, Table_SelectOrder, Table_SelecteMultiOrders } from "../../../../Redux/actions/actionNames";
import Typography from "../../../../design-system/lib/Typography";
import Tag from "../../../../design-system/lib/Tag";
import styles from '../style.module.css';
import momentJalaali from "moment-jalaali";
import { checkTimestamp, get_calendarType, get_currencyCode, get_lang } from '../../../../helper/UserData/userdate';
import Checkbox from '../../../../design-system/lib/Checkbox';
import TooltipOnro from '../../../../design-system/lib/Tooltip';
import Button from '../../../../design-system/lib/Button';
import { BARCODE, COPY, LINK_CIRCLE, RECEIPT, THREDOTS } from '../../../../assets';
import history from '../../../../service/history';
import { restClient } from '../../../../service/API/axios';
import { snack } from '../../../../utils/SnackbarUtilsConfigurator';
import { v4 as uuidv4 } from 'uuid';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { size } from 'lodash';
import { LocalData } from '../../../../service/localStorage';
 import IconProvider from '../../../../design-system/lib/IconProvider';
import { Popover } from '@material-ui/core';
import { DownloadReactStatesdsd } from '../../../../utils/downloadReactState';
import { lengthFormatter, metersToMiles } from '../../../new-order/estimate-path-time';
const localData = new LocalData();

function getDefTableDefaultColumn(t){
  let storeData = store.getState();

  return [
  // {
  //   headerName: '',
  //   checkboxSelection: true,
  //   width: 50,
  // },
  {
    headerName: t('Code'),
    field: 'code',
    width: 90,
    pinned :"left",
    cellRenderer: params => (
      <div onClick={() => history.push(`/order/${params.data.id}`)} style={{ cursor: "pointer" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='Primary' text={params.value} />
      </div>
    )
  },
  {
    headerName: t('OrderType'),
    field: 'type',
    minWidth: 50,
    cellRenderer: params => (
         <Tag weight='Body_Small_Medium' backgroundColor='GrayUltraLight' color='TextDark' size='Large' text={params.value} style={{ marginInlineStart: "0px", borderRadius: "8px" }} />
     )
  },
      {
     field: 'more',
 
    pinned :"right",
        minSize: 50,
      with: 50,
      maxWidth: 50,
      headerName: "More" ,
        headerComponent:  () => (
  <div className="flex items-center" style={{display:"flex", width:"-webkit-fill-available" , fontSize:"13px",fontWeight:"700",justifyContent:"center" , alignItems:"center"}}>
  ...
  </div>
),
 
       cellRenderer: params => (
              <div style={{ display: 'flex', cursor :"pointer ", flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
 
          <CustomPopover t={t} row={params?.data} />
        </div>
      ),
    },
  {
    headerName: t('Stage'),
    field: 'stage',
    width: 80,
    minWidth: 30,
     width : 130 ,
    cellRenderer: params => (
      <div>
        <Tag weight='Body_Small_Medium' backgroundColor='GrayUltraLight' color='TextDark' size='Large' text={params.value} style={{ marginInlineStart: "0px", borderRadius: "8px" }} />
      </div>
    )
  },
  {
    headerName: t('Status'),
    field: 'status',
    minWidth: 50,
    width : 130 ,
    cellRenderer: params => (
      <div >
        <Tag weight='Body_Small_Medium' backgroundColor='GrayUltraLight' color='TextDark' size='Large' text={params.value} className={styles[params.value]} />
      </div>
    )
  },
  {
    headerName: t('Route'),
    field: 'routeName',
    width : 130 ,
    minWidth: 50,
    cellRenderer: params => (
      <div>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'           text={(params.value && String(params.value).length > 0) ? params.value : '---'} className={styles.ellipsis}
 />
      </div>
    )
  },
  {
    headerName: t('CreatedAt'),
    field: 'createdAt',
    width: 110,
    cellRenderer: params => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={momentJalaali(params.value).locale(get_calendarType()).format(checkTimestamp(params.value))}
          className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('DeliveryMethod'),
    field: 'deliveryMethod.title',
    width: 110,
    cellRenderer: params => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark' text={params.value} className={styles.ellipsis} />
      </div>
    )
  },
  {
    headerName: t('StatusUpdatedAt'),
    field: 'statusUpdatedAt',
    minWidth: 50,
    cellRenderer: params => (
      <div>
        <Typography weight='Body_Small_Regular' textColor='TextDark'
          text={momentJalaali(params.value).locale(get_calendarType()).format(checkTimestamp(params.value))}
          style={{ marginInlineStart: "0px", borderRadius: "8px" }} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('Zone'),
    field: 'zone.name',
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={(params.value && String(params.value).length > 0) ? params.value : '---'} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('Note'),
    field: 'note',
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={(params.value && String(params.value).length > 0) ? params.value : '---'} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('Delivery Last Attempt Reason'),
    field: 'delivery.lastAttemptReason.text',
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={(params.value && String(params.value).length > 0) ? params.value : '---'} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('Delivery Attempts Count'),
    field: 'delivery.attemptsCount',
    minWidth: 50,
    width: 150,
    cellRenderer: params => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Tag weight='Body_Small_Regular' textColor='TextDark' text={params.value} className={styles.ellipsis} />
      </div>
    )
  },
  {
    headerName: t('Pickup Failed Reason'),
    field: 'pickup.failedReason.text',
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={(params.value && String(params.value).length > 0) ? params.value : '---'} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('ReferenceId'),
    field: 'referenceId',
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={String(params.value).length > 1 ? params.value : '---'} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('PickupAddress'),
    field: 'pickup.address',
    minWidth: 50,
    width: 200,
    cellRenderer: params => (
      <TooltipOnro tooltipClassName={styles.tooltipClassName} title={
        <div className={styles.tooltipContainer}>
          <Typography weight="Body_Small_Medium" text={params.value} textColor='TextDark' style={{ paddingInline: "10px" }} />
          <span className={styles.divider} />
          <CopyToClipboard text={params.value} onCopy={() => snack.success(t("Saved"))}>
            <Button size='Medium' type='Secondary' icon={COPY} style={{ background: "unset" }} />
          </CopyToClipboard>
        </div>
      } placement='top'>
        <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
          <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
            text={params.value} className={styles.ellipsis}
          />
        </div>
      </TooltipOnro>
    )
  },
  {
    headerName: t('PickupServicePoint'),
    field: 'pickup.servicePoint.name',
    minWidth: 50,
    width: 200,
    cellRenderer: params => (
      <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
        <Typography weight='Body_Small_Regular' textColor='TextDark' text={params.value} style={{ paddingInline: "12px" }} className={styles.ellipsis} />
      </div>
    )
  },
  {
    headerName: t('DeliveryAddress'),
    field: 'delivery.address',
    minWidth: 50,
    width: 200,
    cellRenderer: params => (
      <TooltipOnro tooltipClassName={styles.tooltipClassName} title={
        <div className={styles.tooltipContainer}>
          <Typography weight="Body_Small_Medium" text={params.value} textColor='TextDark' style={{ paddingInline: "10px" }} />
          <span className={styles.divider} />
          <CopyToClipboard text={params.value} onCopy={() => snack.success(t("Saved"))}>
            <Button size='Medium' type='Secondary' icon={COPY} style={{ background: "unset" }} />
          </CopyToClipboard>
        </div>
      } placement='top'>
        <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
          <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
            text={params.value} className={styles.ellipsis}
          />
        </div>
      </TooltipOnro>
    )
  },
  {
    headerName: t('DeliveryServicePoint'),
    field: 'delivery.servicePoint.name',
    minWidth: 50,
    width: 200,
    cellRenderer: params => (
      <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
        <Typography weight='Body_Small_Regular' textColor='TextDark' text={params.value} style={{ paddingInline: "12px" }} className={styles.ellipsis} />
      </div>
    )
  },
  {
    headerName: t('Driver Name'),
    field: 'driver.name',
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Tag weight='Body_Small_Regular' textColor='TextDark' text={(params.value && String(params.value).length > 0) ? params.value : '---'} className={styles.ellipsis} />
      </div>
    )
  },
  {
    headerName: t('Driver Phone'),
    field: 'driver.phone',
    width: 112,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Tag weight='Body_Small_Regular' textColor='TextDark' text={(params.value && String(params.value).length > 0) ? params.value : '---'} className={styles.ellipsis} />
      </div>
    )
  },
  {
    headerName: t('Customer Name'),
    field: 'customer.name',
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Tag weight='Body_Small_Regular' textColor='TextDark' text={(params.value && String(params.value).length > 0) ? params.value : '---'} className={styles.ellipsis} />
      </div>
    )
  },
  {
    headerName: t('Customer Phone'),
    field: 'customer.phone',
    width: 122,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Tag weight='Body_Small_Regular' textColor='TextDark'
          text={params.value
            ? (String(params.value).startsWith('+')
                ? params.value
                : (String(params.value).startsWith('00')
                    ? '+' + String(params.value).slice(2)
                    : ''))
            : '---'}
          className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('Service'),
    field: 'service.title',
    minWidth: 50,
    cellRenderer: params => (
      <div>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark' text={params.value || '------'} />
      </div>
    )
  },
  {
    headerName: t('Price'),
    field: 'price',
    width: 55,
    minWidth: 50,
    cellRenderer: params => (
      <div>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={Number(params.value).toLocaleString(get_lang(), { style: "currency", currency: get_currencyCode(), minimumFractionDigits: 0 , maximumFractionDigits: 2 })}
        />
      </div>
    )
  },
  {
    headerName: t('COD'),
    field: 'codAmount',
    minWidth: 40,
     cellRenderer: params => (
      <div>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={Number(params.value).toLocaleString(get_lang(), { style: "currency", currency: get_currencyCode(), minimumFractionDigits: 0 , maximumFractionDigits: 2 })}
        />
      </div>
    )
  },
  {
    headerName: t('EstimatedDistanceInMeters'),
    field: 'estimatedDistanceInMeters',
    minWidth: 50,
    cellRenderer: params => (
      <div>
        <Tag weight='Body_Small_Medium' backgroundColor='GrayUltraLight' color='TextDark' size='Large' text={lengthFormatter(storeData.SharedData.settings.lengthUnit == "mile" ? metersToMiles(Number(params.value)) : Number(params.value) / 1000 , storeData.SharedData.settings.lengthUnit , storeData.SharedData.settings.lengthUnitFormat)} style={{ marginInlineStart: "0px", borderRadius: "8px" }} />
      </div>
    )
  },
  {
    headerName: t('EstimatedDuration'),
    field: 'estimatedDuration',
    width: 137,
    minWidth: 50,
    cellRenderer: params => (
      <div>
        <Tag weight='Body_Small_Medium' backgroundColor='GrayUltraLight' color='TextDark' size='Large' text={formatDuration(params.value)} style={{ marginInlineStart: "0px", borderRadius: "8px" }} />
      </div>
    )
  },
  {
    headerName: t('Method'),
    field: 'paymentMethod',
    minWidth: 50,
    cellRenderer: params => (
      <div>
        <Tag weight='Body_Small_Medium' backgroundColor='GrayUltraLight' color='TextDark' size='Large'
          text={params.data ? `${params.data?.paymentSide}${params.data?.paymentMethod}` : "-----"}
          style={{ marginInlineStart: "0px", borderRadius: "8px" }}
        />
      </div>
    )
  },
  {
    headerName: t('PickupAddressDetail'),
    field: 'pickup.addressDetail',
    width: 200,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark' text={params.value} className={styles.ellipsis} />
      </div>
    )
  },
  {
    headerName: t('PickupCompleteAfter'),
    field: 'pickup.completeAfter',
    width: 148,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={params.value ? momentJalaali(params.value).locale(get_calendarType()).format(checkTimestamp(params.value)) : "---"}
          className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('PickupcompleteBefore'),
    field: 'pickup.completeBefore',
    width: 155,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={params.value ? momentJalaali(params.value).locale(get_calendarType()).format(checkTimestamp(params.value)) : "---"}
          className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName:  t('PickupFullName'),
    field: 'pickup.fullName',
    width: 200,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={String(params.value).length > 0  ? params.value : "---"} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName:  t('PickupPhone'),
    field: 'pickup.phone',
    width: 123,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={String(params.value).length > 0  ? params.value : "---"} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName:  t('PickupEmail'),
    field: 'pickup.email',
    width: 200,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={String(params.value).length > 0  ? params.value : "---"} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName:  t('PickupPodNote'),
    field: 'pickup.podNote',
    width: 200,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={String(params.value).length > 0  ? params.value : "---"} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName:  t('PickupPodPhoto'),
    field: 'pickup.podPhoto',
    width: 200,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex', paddingInlineStart: "21px" }}>
        <Button size='Medium' type='Secondary' icon={LINK_CIRCLE} disabled={String(params.value).length === 0} onClick={() => {
          try {
            const url = new URL(params.value);
            window.open(`${url.toString()}?lng=${get_lang()}`, '_blank');
          } catch {}
        }} />
      </div>
    )
  },
  {
    headerName:  t('PickupPodSignature'),
    field: 'pickup.podSignature',
    width: 200,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex', paddingInlineStart: "21px" }}>
        <Button size='Medium' type='Secondary' icon={LINK_CIRCLE} disabled={String(params.value).length === 0} onClick={() => {
          try {
            const url = new URL(params.value);
            window.open(`${url.toString()}?lng=${get_lang()}`, '_blank');
          } catch {}
        }} />
      </div>
    )
  },
  {
    headerName:   t('PickupZone'),
    field: 'pickup.zone.name',
    width: 200,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={(params.value && String(params.value).length > 0) ? params.value : '---'} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName:  t('DeliveryAddressDetail'),
    field: 'delivery.addressDetail',
    width: 200,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark' text={params.value} className={styles.ellipsis} />
      </div>
    )
  },
  {
    headerName: t('DeliveryCompleteAfter'),
    field: 'delivery.completeAfter',
    width: 157,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={params.value ? momentJalaali(params.value).locale(get_calendarType()).format(checkTimestamp(params.value)) : "---"} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('DeliverycompleteBefore'),
    field: 'delivery.completeBefore',
    width: 163,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={params.value ? momentJalaali(params.value).locale(get_calendarType()).format(checkTimestamp(params.value)) : "---"} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('DeliveryFullName'),
    field: 'delivery.fullName',
    width: 200,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={String(params.value).length > 0  ? params.value : "---"} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('DeliveryPhone'),
    field: 'delivery.phone',
    width: 110,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={String(params.value).length > 0  ? params.value : "---"} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('DeliveryEmail'),
    field: 'delivery.email',
    width: 200,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={String(params.value).length > 0  ? params.value : "---"} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('DeliveryPodNote'),
    field: 'delivery.podNote',
    width: 200,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={String(params.value).length > 0  ? params.value : "---"} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('DeliveryPodPhoto'),
    field: 'delivery.proofs',
    width: 200,
    minWidth: 50,
    cellRenderer: params => {
      const photoProof = params.value.find(item => item.type === "photo");
      return (
        <div style={{ display: 'flex', paddingInlineStart: "21px" }}>
          <Button size='Medium' type='Secondary' icon={LINK_CIRCLE} disabled={!photoProof} onClick={() => {
            try {
              const url = new URL(photoProof.photoUrl);
              window.open(`${url.toString()}?lng=${get_lang()}`, '_blank');
            } catch {}
          }} />
        </div>
      );
    }
  },
  {
    headerName:  t('DeliveryPodSignature'),
    field: 'delivery.proofs',
    width: 200,
    minWidth: 50,
    cellRenderer: params => {
      const sigProof = params.value.find(item => item.type === "signature");
      return (
        <div style={{ display: 'flex', paddingInlineStart: "21px" }}>
          <Button size='Medium' type='Secondary' icon={LINK_CIRCLE} disabled={!sigProof} onClick={() => {
            try {
              const url = new URL(sigProof.signatureUrl);
              window.open(`${url.toString()}?lng=${get_lang()}`, '_blank');
            } catch {}
          }} />
        </div>
      );
    }
  },
  {
    headerName: t('DeliveryZone'),
    field: 'delivery.zone.name',
    width: 200,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "start", height: "40px" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={(params.value && String(params.value).length > 0) ? params.value : '---'} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('Driver Vehicle'),
    field: 'driver.vehicle',
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Tag weight='Body_Small_Regular' textColor='TextDark'
          text={params.value
            ? `${params.value.color} ${params.value.model} | ${params.value.plate}`
            : '---'}
          className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('Driver Username'),
    field: 'driver.phone',
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Tag weight='Body_Small_Regular' textColor='TextDark'
          text={params.value
            ? (String(params.value).startsWith('+')
                ? params.value
                : (String(params.value).startsWith('00')
                    ? '+' + String(params.value).slice(2)
                    : ''))
            : '---'}
          className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('CustomerType'),
    field: 'customerType',
    width: 109,
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Tag size='Large' backgroundColor='GrayUltraLight' weight='Body_Small_Regular' textColor='TextDark' text={params.value} />
      </div>
    )
  },
  {
    headerName: t('Customer Email'),
    field: 'customer.email',
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Tag weight='Body_Small_Regular' textColor='TextDark'
          text={String(params.value).length > 0  ? params.value : '---'} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('PaymentProvider'),
    field: 'paymentProvider',
    minWidth: 50,
    cellRenderer: params => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Typography style={{ marginInlineStart: "0px" }} weight='Body_Small_Regular' textColor='TextDark'
          text={params.value && String(params.value).length > 1 ? params.value : '---'} className={styles.ellipsis}
        />
      </div>
    )
  },
  {
    headerName: t('Source'),
    field: 'source',
    width: 90,
    minWidth: 10,
    cellRenderer: params => (
      <div>
        <Tag weight='Body_Small_Medium' backgroundColor='GrayUltraLight' color='TextDark' size='Large' text={params.value} style={{ marginInlineStart: "0px", borderRadius: "8px" }} />
      </div>
    )
  },
  // {
  //   headerName: t('Receipt'),
  //   field: 'customerReceiptUrl',
  //   minWidth: 50,
  //    cellRenderer: params => (
  //     <div style={{ display: 'flex', paddingInlineStart: "21px" }}>
  //       <Button size='Medium' type='Secondary' icon={LINK_CIRCLE}
  //         disabled={!['Done','Delivered'].includes(params.data?.status)}
  //         onClick={() => {
  //           try {
  //             const url = new URL(params.value);
  //             url.searchParams.append("lng", get_lang());
  //             window.open(url.toString(), "_blank");
  //           } catch {}
  //         }} />
  //     </div>
  //   )
  // },
  // {
  //   headerName:t('Shipment Label'),
  //   field: 'shipmentLabelUrl',
  //   minWidth: 50,
  //    cellRenderer: params => (
  //     <div style={{ display: 'flex', paddingInlineStart: "21px" }}>
  //       <Button size='Medium' type='Secondary' icon={LINK_CIRCLE} onClick={() => {
  //         console.log("vdsvdv ",params)
  //         restClient.post('/api/v1/dispatcher/order/shipment-label/export-pdf',
  //           { ids: [params.data?.id.toString()] },
  //           { responseType: 'blob', headers: { withCredentials: true, 'x-bypass-auth': true } }
  //         ).then(response => {
  //           const blob = new Blob([response.data], { type: 'application/pdf' });
  //           const link = document.createElement('a');
  //           link.href = URL.createObjectURL(blob);
  //           link.download = response.headers["content-disposition"].replace("attachment; filename=", '');
  //           document.body.appendChild(link);
  //           link.click();
  //           document.body.removeChild(link);
  //           snack.success_i18('Shipmentlabeldownloaded');
  //         });
  //       }} />
  //     </div>
  //   )
  // },
  // {
  //   headerName: t('Track Order'),
  //   field: 'trackOrder',
  //   minWidth: 50,
  //    cellRenderer: params => (
  //     <div style={{ display: 'flex', paddingInlineStart: "21px" }}>
  //       <Button size='Medium' type='Secondary' icon={LINK_CIRCLE} onClick={() => {
  //         try {
  //           const url = new URL(params.value);
  //           window.open(`${url.toString()}?lng=${get_lang()}`, '_blank');
  //         } catch {}
  //       }} />
  //     </div>
  //   )
  // }



  ]

}


 

export let getTableDefaultColumn = (t) => {

  const xxx = getDefTableDefaultColumn(t);


  // بارگیری ترتیب ستون ها از localStorage
  let orderFromStorage;
  try {
    const raw = localStorage.getItem("customTable");
   // DownloadReactStatesdsd(JSON.parse(raw))
    if (raw) { 
 
      orderFromStorage = JSON.parse(raw);
      if (!Array.isArray(orderFromStorage)) orderFromStorage = undefined;
    }else{
     orderFromStorage = [{"colId":"code","width":90,"hide":false,"pinned":"left","sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"more","width":50,"hide":false,"pinned":"right","sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"referenceId","width":200,"hide":false,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"type","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"stage","width":130,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"status","width":130,"hide":false,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"routeName","width":130,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"createdAt","width":110,"hide":false,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"deliveryMethod.title","width":110,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"statusUpdatedAt","width":200,"hide":false,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"zone.name","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"delivery.lastAttemptReason.text","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"delivery.attemptsCount","width":150,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"pickup.failedReason.text","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"pickup.servicePoint.name","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"delivery.servicePoint.name","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"driver.name","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"driver.phone","width":112,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"driver.phone_1","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"customer.phone","width":122,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"service.title","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"price","width":55,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"codAmount","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"estimatedDistanceInMeters","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"estimatedDuration","width":137,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"paymentMethod","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"pickup.completeAfter","width":148,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"pickup.completeBefore","width":155,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"pickup.fullName","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"pickup.phone","width":123,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"pickup.email","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"pickup.podNote","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"pickup.podPhoto","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"pickup.podSignature","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"pickup.zone.name","width":200,"hide":false,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"delivery.completeAfter","width":157,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"delivery.completeBefore","width":163,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"delivery.email","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"delivery.podNote","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"delivery.proofs","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"delivery.proofs_1","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"pickup.addressDetail","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"delivery.zone.name","width":200,"hide":false,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"pickup.address","width":200,"hide":false,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"delivery.address","width":200,"hide":false,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"delivery.addressDetail","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"note","width":200,"hide":false,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"customer.name","width":200,"hide":false,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"delivery.fullName","width":200,"hide":false,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"delivery.phone","width":110,"hide":false,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"driver.vehicle","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"customerType","width":109,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"customer.email","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"paymentProvider","width":200,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null},{"colId":"source","width":90,"hide":true,"pinned":null,"sort":null,"sortIndex":null,"aggFunc":null,"rowGroup":false,"rowGroupIndex":null,"pivot":false,"pivotIndex":null,"flex":null}]
    
   
    }
  } catch (e) {
    orderFromStorage = undefined;
  }

  // مپ اندیس برای جستجو سریع
  const indexMap = Object.create(null);
  if (Array.isArray(orderFromStorage)) {
    orderFromStorage.forEach((fieldName, idx) => {
      indexMap[fieldName.colId] = idx;
    });
  }

  // تبدیل و اضافه کردن خصوصیات قبلی
  const transformed = xxx.map((item) => {
    return {
      ...item,
      ...(item.field !== 'createdAt' && item.field !== 'statusUpdatedAt' && { sortable: false }),
      size: localData.get(`ReduxLocal_header_${item.id}_ColumnSize`)
        ? localData.get(`ReduxLocal_header_${item.id}_ColumnSize`)
        : (item.size ? item.size : null)
    };
  });

  // اگر order وجود داشت، مرتب کن بر اساس آن
  const sorted = transformed.slice().sort((a, b) => {
    const ai = (a.field in indexMap) ? indexMap[a.field] : Number.MAX_SAFE_INTEGER;
    const bi = (b.field in indexMap) ? indexMap[b.field] : Number.MAX_SAFE_INTEGER;
    return ai - bi;
  });

  // فیلتر کردن خروجی: اگر order وجود داشت، فقط فیلدهایی که در order هستند را برگردان
   const result =  sorted.map((item)=>{
    return {...item, hide: orderFromStorage?.[indexMap[item.field]]?.hide || false}  
  });

  return result;
};

const defaultColumns = [
  {
    id: 'select',
    isFirst: true,
    size: 50,
    minSize: 50,
    maxSize: 50,
    header: ({ table }) => (
      <IndeterminateCheckboxHeader
        {...{
          checked: table.getIsAllRowsSelected(),
          indeterminate: table.getIsSomeRowsSelected(),
          onChange: table.getToggleAllRowsSelectedHandler(),
          isheader: true
        }}
      />
    ),
    cell: ({ row }) => (
      <div>
        <IndeterminateCheckbox
          {...{
            checked: row.getIsSelected(),
            disabled: !row.getCanSelect(),
            indeterminate: row.getIsSomeSelected(),
            onChange: row.getToggleSelectedHandler(),
            style: { marginInlineStart: "16px" },
            isheader: false
          }}

        /></div>
    ),
  },
  {
    accessorKey: 'OrderID',
    header: 'Code',
    id: 'OrderID',
    minSize: 50,
    cell: (row) => (
      <div>
        <Typography weight='Body_Small_Regular' textColor='TextDark' text={row.getValue()}  />
      </div>

    ),
  },
  {
    accessorKey: 'OrderType',
    cell: (row) => (
      <div >
        <Tag weight='Body_Small_Medium' backgroundColor='GrayUltraLight' color='TextDark' size='Large' text={row.getValue()} style={{ marginInlineStart: "0px", borderRadius: "8px" }} />
      </div>

    ),
    id: 'OrderType',
    minSize: 50,

  },
  {
    accessorFn: row => row.Stage,
    id: 'Stage',
    header: <span>Stage</span>,
    cell: (row) => (
      <div >
        <Tag weight='Body_Small_Medium' backgroundColor='GrayUltraLight' color='TextDark' size='Large' text={row.getValue()} style={{ marginInlineStart: "0px", borderRadius: "8px" }} />
      </div>

    ),
    minSize: 50,
    maxSize: 90
  },



  {
    accessorKey: 'Status',
    header: 'Status',

    id: 'Status',
    minSize: 50,
    cell: (row) => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Tag weight='Body_Small_Medium' backgroundColor='GrayUltraLight' color='TextDark' size='Large' text={row.getValue()} className={styles[row.getValue()]} />
      </div>

    ),
  },

  {
    accessorKey: 'Route',
    header:"Route",

    id: 'Route',
    minSize: 50,
    cell: (row) => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Typography weight='Body_Small_Regular' textColor='TextDark' text={row.getValue()}  className={styles.ellipsis} />
      </div>

    ),
  },

  {
    accessorKey: 'CreatedAt',
    header: 'CreatedAt',

    id: 'createdAt',
    minSize: 50,
    cell: (row) => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Typography weight='Body_Small_Regular' textColor='TextDark' text={row.getValue()}  className={styles.ellipsis} />
      </div>

    ),
  },
  {
    accessorKey: 'PickupAddress',
    header: 'PickupAddress',

    id: 'PickupAddress',
    minSize: 50,
    size: 200,
    cell: (row) => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Typography weight='Body_Small_Regular' textColor='TextDark' text={row.getValue()}  className={styles.ellipsis} />
      </div>

    ),
  }, {
    accessorKey: 'PickupDriver',
    header: 'PickupDriver',
    cell: (row) => (
      <div>
        <Typography weight='Body_Small_Regular' textColor='TextDark' text={row.getValue()}  className={styles.ellipsis} />
      </div>

    ),
    id: 'PickupDriver',
    minSize: 50,
  }, {
    accessorKey: 'DeliveryAddress',
    header: 'DeliveryAddress',

    id: 'DeliveryAddress',
    size: 200,
    minSize: 50,
    cell: (row) => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Typography weight='Body_Small_Regular' textColor='TextDark' text={row.getValue()}  className={styles.ellipsis} />
      </div>

    ),
  }, {
    accessorKey: 'DeliveryDriver',
    header: 'DeliveryDriver',
    cell: (row) => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Typography weight='Body_Small_Regular' textColor='TextDark' text={row.getValue()}  className={styles.ellipsis} />
      </div>

    ),
    id: 'DeliveryDriver',
    minSize: 50,
  }, {
    accessorKey: 'Schedule',
    header: 'Schedule',
    cell: (row) => (
      <div style={{ display: 'flex' ,height:"100%" ,alignItems:"center" }}>
        <Typography weight='Body_Small_Regular' textColor='TextDark' text={row.getValue()}  className={styles.ellipsis} />
      </div>

    ),
    id: 'Schedule',
    minSize: 50,
  },


]



function IndeterminateCheckbox({
  indeterminate,
  className = '',
  checked,
  onChange,
  disabled,
  style,
  isheader,
  ...row

}) {
  const ref = React.useRef(null)
  const dispatch = useDispatch();
  const data = useSelector((state) => state.Table.list.orders)
  const selectedOrders = useSelector((state) => state.Table.selectedOrders)


  const onChangex = useCallback((e) => {

    if (row?.original) {
      if (ischecked()) {
        dispatch(Table_DeSelectOrder(row.original.id))
      } else {
        dispatch(Table_SelectOrder(row.original))
      }
    } else {
      return false
    }
  }, [data, row]);



  const ischecked = useCallback((e) => {

    console.log(" ischecked ", row)
    if (row) {
      if (row.original) {
        return selectedOrders[row.original.id]
      } else {
        return false
      }
    } else {
      return false
    }

  }, [data, row]);

  return (
    <Checkbox size='Small' state={ischecked() ? "checked" : "unchecked"} onClick={(e) => { onChangex(e) }} style={{ marginLeft: "16px" }} />

  )
}


function IndeterminateCheckboxHeader({
  indeterminate,
  className = '',
  checked,
  onChange,
  disabled,
  style,
  isheader,
  ...row

}) {
  const ref = React.useRef(null)
  const dispatch = useDispatch();
  const data = useSelector((state) => state.Table.list.orders)
  const selectedOrders = useSelector((state) => state.Table.selectedOrders)

  const checkAll = useCallback((e) => {
    dispatch(Table_SelecteMultiOrders(data))

  }, [data]);

  const uncheckAll = useCallback((e) => {
    dispatch(Table_ClearSelectedOrders())
  }, [data]);



  const allischecked = useCallback((e) => {

    let all = true

    data?.forEach((key2) => {
      if (!selectedOrders[key2.id]) {

        all = false;
      }
    })

    return all

  }, [data, selectedOrders]);


  const someischecked = useCallback((e) => {

    let all = false

    data.forEach((key2) => {
      if (selectedOrders[key2.id]) {

        all = true;
      }
    })

    return all

  }, [data, selectedOrders]);

  return (

    <Checkbox size='Small' state={(!allischecked() && someischecked()) ? "indeterminate" : (allischecked() ? "checked" : "unchecked")} onClick={(e) => { allischecked() ? uncheckAll(e) : checkAll(e) }} style={{ marginLeft: "3px" }} />

  )
}




const CustomPopover = ({ row , t}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
    const [showeditAnchorEl, setShowEditAnchorEl] = useState(false);
    const editAnchorEl = useRef(null);

  useEffect(() => {
    const onScroll = () => setIsOpen(false);
    $("#maintbody").on('scroll', function () {
      setIsOpen(false)
    });
  }, []);



 

 

  return (
    <>
 

    	<Popover
            open={showeditAnchorEl}
        anchorEl={editAnchorEl.current}
				onClose={()=>{setShowEditAnchorEl(false)}}
						 style={{ marginTop: "6px" , marginInlineStart:"13px",
              borderRadius:"8px",
 							}} // فاصله 16 پیکسل از بالای دکمه
							sx={{}}
  anchorOrigin={{
    vertical: 'bottom',      // Popover از پایین عنصر باز می‌شود
    horizontal: 'center',
  }}
  transformOrigin={{
    vertical: 'top',         // مبدأ Popover از بالای خودش باشد
    horizontal: 'right',
  }}
				classes={{ paper: styles.Popover }}
			>
			<  >

        <div className={styles.PopoverItem}  onClick={() => {
          try {
            const url = new URL(row?.trackOrder);
            window.open(`${url.toString()}?lng=${get_lang()}`, '_blank');
            setShowEditAnchorEl(false)
          } catch {}
        }}>
          <IconProvider Icon={LINK_CIRCLE} />
          <Typography weight='Body_Middle_Regular' text={t('Track Order')} />
        </div>

        <div className={styles.PopoverItem} onClick={() => {
           restClient.post('/api/v1/dispatcher/order/shipment-label/export-pdf',
            { ids: [row?.id.toString()] },
            { responseType: 'blob', headers: { withCredentials: true, 'x-bypass-auth': true } }
          ).then(response => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = response.headers["content-disposition"].replace("attachment; filename=", '');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            snack.success_i18('Shipmentlabeldownloaded');
            setShowEditAnchorEl(false)
          });
        }}>
          <IconProvider Icon={BARCODE} />

          <Typography weight='Body_Middle_Regular' text={t('Shipment Label')} />
        </div>
         
      <div className={styles.PopoverItem}  onClick={() => {
            try {
              const url = new URL(row?.customerReceiptUrl);
              url.searchParams.append("lng", get_lang());
              window.open(url.toString(), "_blank");
              setShowEditAnchorEl(false)
            } catch {}
          }} >
          <img src={RECEIPT} style={{width:"16px"}} />
          <Typography weight='Body_Middle_Regular' text={ t('Receipt')} />
      </div>  

        
 
        
          </ >
			</Popover>
 
      <img ref={editAnchorEl} onClick={() => {
        setShowEditAnchorEl(!showeditAnchorEl);
      }} src={THREDOTS} />
    </>
  );
};


    const formatDuration  = (durationSeconds) => {
  
       let durationString = '';
  
 
  
      // پردازش زمان
      if (durationSeconds !== undefined && durationSeconds !== null) {
          if (durationSeconds < 60) {
              durationString = `${durationSeconds}s`;
          } else if (durationSeconds < 3600) {
              let minutes = Math.floor(durationSeconds / 60);
              durationString = `${minutes}m`;
          } else {
              let hours = Math.floor(durationSeconds / 3600);
              let minutes = Math.floor((durationSeconds % 3600) / 60);
              if (minutes > 0) {
                durationString = `${hours}h , ${minutes}m`;
            } else {
                durationString = `${hours}h`;
            }
          }
      }
  
      return durationString;
      } 
 